import {useNavigate, useSearchParams} from 'react-router-dom';

export default function NewsItem ({ data: { id, title, thumbnail, createDate } }) {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const click = () => {
    navigate(`/news/detail/${id}?${searchParams.toString()}`);
  }

  return (
    <div className='flex flex-col justify-center w-full lg:w-[calc(50%-44px)] cursor-pointer'>
      <img
        className='aspect-[560/340] bg-center object-cover rounded-[12px]'
        src={`${process.env.REACT_APP_STATIC_URL}/images/News/${thumbnail}`}
        alt={title}
        onClick={click}
      />

      <p className='mt-[20px] lg:mt-[46px] text-label1 lg:text-heading2 text-label-0'>{createDate}</p>
      <p onClick={click} className='mt-[4px] lg:mt-[10px] font-semibold text-heading3 lg:text-title3 text-label-300'>
        {title}
      </p>
    </div>
  )
}